
import clsx from "clsx";

export type CalloutVariant = "info" | "warning" | "danger" | "success";

export interface CalloutProps {
  variant?: CalloutVariant;
  icon?: React.ReactNode;
  title?: string;
  children: React.ReactNode;
  className?: string;
}

const variantClasses: Record<CalloutVariant, string> = {
  info: "callout-info",
  warning: "callout-warning",
  danger: "callout-danger",
  success: "callout-success",
};

const defaultIcons: Record<CalloutVariant, string> = {
  info: "fa-solid fa-circle-info",
  warning: "fa-solid fa-triangle-exclamation",
  danger: "fa-solid fa-circle-exclamation",
  success: "fa-solid fa-circle-check",
};

export function Callout({
  variant = "info",
  icon,
  title,
  children,
  className,
}: CalloutProps) {
  return (
    <div className={clsx("callout", variantClasses[variant], className)}>
      <div className="flex-shrink-0">
        {icon || <i className={defaultIcons[variant]} />}
      </div>
      <div className="flex-1">
        {title && <div className="font-semibold mb-1">{title}</div>}
        <div className="text-sm opacity-90">{children}</div>
      </div>
    </div>
  );
}

export default Callout;
